import React, { Component } from "react";
import {
  loading,
  alert,
  NavbarAdmin,
  Modal,
  format_date,
  GET,
  PUT,
  t,
  can,
} from "../../components/CustomComponent.js";
import {
  EMPTY_GROUP,
  FEATURE_ICONS,
  ADMIN_ICON,
  clone,
  ordered,
  moveItem,
  nextSort,
  newUid,
} from "../../components/homepage_option.js";
import "../../assets/css/property.css";
import "../../assets/css/people.css";
import "../../assets/css/property_type.css";
import "../../assets/css/home_manage.css";
import "../../assets/css/homepage.css";

/* ============================================================================
 * จัดการหน้าแรก › ทำไมต้องเลือก Munera  (/ad/home/features)
 *
 * ส่วนสร้างความมั่นใจก่อนลูกค้าติดต่อ ประกอบด้วย
 *   - หัวข้อของส่วนนี้
 *   - การ์ดจุดเด่นบริการ (ไอคอน + หัวข้อ + คำอธิบายสั้น) เพิ่ม/ลบ/เรียงลำดับได้
 *   - แถบตัวเลขความน่าเชื่อถือ 4 ช่อง แก้ได้ในตารางเลย
 * หน้าเว็บวางการ์ดจุดเด่นไว้ซ้ายและแถบตัวเลขไว้ขวาในแถวเดียวกัน คำอธิบายในการ์ด
 * จึงควรสั้น 1 บรรทัด (การ์ดกว้างราว 130px)
 * กล่องพรีวิวใช้ CSS ชุดเดียวกับหน้าเว็บจริง (.hm-features / .hm-stats)
 *
 * ข้อมูลอ่าน/บันทึกผ่าน API จริง
 *   GET  admin/homepage/feature
 *   PUT  admin/homepage/feature   (ส่ง { section, items, stats })
 * บันทึกแบบแทนที่ทั้งชุด — จัดลำดับ/เปิด-ปิดในหน้าจอจนพอใจแล้วค่อยกดบันทึกครั้งเดียว
 * ========================================================================== */

const EMPTY_FORM = { icon: FEATURE_ICONS[0], title: "", desc: "", is_active: true };

const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");

export default class HomeFeatureSetting extends Component {
  constructor(props) {
    super(props);
    const data = clone(EMPTY_GROUP.feature);
    this.state = {
      section: data.section,
      items: data.items,
      stats: data.stats,
      saved: clone(data),

      modal_form: false,
      edit_uid: "",
      form: { ...EMPTY_FORM },
      updated_at: "",
      updated_by: "",
    };
  }

  componentDidMount() {
    loading(false);
    this.Get();
  }

  /* โหลดเนื้อหากลุ่มนี้จากฐานข้อมูล — เรียกทั้งตอนเปิดหน้าและหลังบันทึกสำเร็จ
     เพื่อให้ uid ของรายการที่เพิ่งสร้างตรงกับฝั่ง server */
  Get = async () => {
    loading(true);
    const result = await GET("admin/homepage/feature", {});
    loading(false);
    if (result?.status && result.data) this.Apply(result.data);
  };

  Apply = (data) =>
    this.setState({
      section: data.section,
      items: data.items || [],
      stats: data.stats || [],
      saved: clone({ section: data.section, items: data.items || [], stats: data.stats || [] }),
      updated_at: data.updated_at || "",
      updated_by: data.updated_by || "",
    });

  current = () => ({ section: this.state.section, items: this.state.items, stats: this.state.stats });

  isDirty = () => JSON.stringify(this.current()) !== JSON.stringify(this.state.saved);

  setSection = (patch) => this.setState((prev) => ({ section: { ...prev.section, ...patch } }));

  setForm = (patch) => this.setState((prev) => ({ form: { ...prev.form, ...patch } }));

  setStat = (uid, patch) =>
    this.setState((prev) => ({ stats: prev.stats.map((row) => (row.uid === uid ? { ...row, ...patch } : row)) }));

  /* ---------------------------------------------------- เปิดฟอร์ม เพิ่ม/แก้ */
  OpenCreate = () => this.setState({ modal_form: true, edit_uid: "", form: { ...EMPTY_FORM } });

  OpenEdit = (item) =>
    this.setState({
      modal_form: true,
      edit_uid: item.uid,
      form: { icon: item.icon, title: item.title || "", desc: item.desc || "", is_active: !!item.is_active },
    });

  CloseForm = () => this.setState({ modal_form: false });

  SaveFeature = () => {
    const { form, edit_uid } = this.state;
    if (!form.title.trim()) return alert("", "warning", t("warning"), t("home_verify_feature_title"));

    const payload = {
      icon: form.icon,
      title: form.title.trim(),
      desc: form.desc.trim(),
      is_active: form.is_active,
    };

    this.setState((prev) => ({
      items: edit_uid
        ? prev.items.map((row) => (row.uid === edit_uid ? { ...row, ...payload } : row))
        : [...prev.items, { ...payload, uid: newUid("ft"), sort: nextSort(prev.items) }],
      modal_form: false,
    }));
  };

  Move = (item, step) => this.setState((prev) => ({ items: moveItem(prev.items, item.uid, step) }));

  ToggleActive = (item) =>
    this.setState((prev) => ({
      items: prev.items.map((row) => (row.uid === item.uid ? { ...row, is_active: !row.is_active } : row)),
    }));

  Delete = async (item) => {
    if (!(await alert("", "warning", t("delete_item"), `${t("home_delete_feature_desc")}\n${item.title}`, t("confirm"), t("cancel")))) return;
    this.setState((prev) => ({ items: prev.items.filter((row) => row.uid !== item.uid) }));
  };

  Save = async () => {
    if (!this.state.section.title.trim()) return alert("", "warning", t("warning"), t("home_verify_section_title"));
    if (!(await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel")))) return;

    loading(true);
    const result = await PUT("admin/homepage/feature", this.current());
    loading(false);
    if (!result?.status) return;

    this.Apply(result.data);
    alert("", "success", t("success"), t("home_save_done"));
  };

  Reset = async () => {
    if (!this.isDirty()) return;
    if (!(await alert("", "warning", t("reset_changes"), t("discard_changes_confirm"), t("confirm"), t("cancel")))) return;
    this.setState((prev) => ({ section: clone(prev.saved.section), items: clone(prev.saved.items), stats: clone(prev.saved.stats) }));
  };

  /* ====================================================== render : ตัวจัดการ */
  renderList = () => {
    const list = ordered(this.state.items);
    const active = list.filter((item) => item.is_active).length;
    const dirty = this.isDirty();
    const { section, stats } = this.state;

    return (
      <div className="prop-card prop-in">
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("home_feature_list_title")}
          </span>
          <div className="hmg-sum">
            <span className="ppl-pill ppl-pill--ghost">
              {list.length} {t("home_unit_card")}
            </span>
            <span className="ppl-pill ppl-pill--on">
              <span className="ppl-pill__dot" />
              {active} {t("active")}
            </span>
            {can("homepage.update") && (
              <button type="button" className="prop-btn prop-btn--ghost" onClick={this.OpenCreate}>
                <span className="icon text-12">{ADMIN_ICON.plus}</span>
                {t("home_add_feature")}
              </button>
            )}
          </div>
        </div>

        {/* หัวข้อของส่วน */}
        <div className="p-4 pb-2">
          <div className="row g-3">
            <div className="col-md-12">
              <label className="prop-label">
                {t("home_section_title")} <span className="text-danger">*</span>
              </label>
              <input type="text" className="prop-field" maxLength={40} value={section.title} onChange={(e) => this.setSection({ title: e.target.value })} />
            </div>
          </div>
        </div>

        <div className="hmg-list">
          {list.map((item, index) => (
            <div className={`hmg-row ${item.is_active ? "" : "is-off"}`} key={item.uid}>
              <div className="d-flex align-items-center gap-2">
                <span className="pty-rank">{index + 1}</span>
                <div className="pty-order">
                  <button type="button" className="pty-order__btn icon" title={t("ptype_move_up")} disabled={index === 0} onClick={() => this.Move(item, -1)}>
                    {ADMIN_ICON.up}
                  </button>
                  <button
                    type="button"
                    className="pty-order__btn icon"
                    title={t("ptype_move_down")}
                    disabled={index === list.length - 1}
                    onClick={() => this.Move(item, 1)}
                  >
                    {ADMIN_ICON.down}
                  </button>
                </div>
              </div>

              <div className="hmg-icon icon">{item.icon}</div>

              <div className="hmg-row__body">
                <div className="hmg-row__title">
                  <span>{item.title}</span>
                </div>
                <div className="hmg-row__desc">{item.desc}</div>
              </div>

              {/* เปิด/ปิด แก้ไข ลบ : ต้องมีสิทธิ์แก้ไขหน้าแรก */}
              {can("homepage.update") && (
                <div className="hmg-row__actions">
                  <label className="ppl-switch" title={item.is_active ? t("home_hide") : t("home_show")}>
                    <input type="checkbox" checked={item.is_active} onChange={() => this.ToggleActive(item)} />
                    <span className="ppl-switch__track" />
                  </label>
                  <button type="button" className="prop-iconbtn prop-iconbtn--dark icon" title={t("edit")} onClick={() => this.OpenEdit(item)}>
                    {ADMIN_ICON.edit}
                  </button>
                  <button
                    type="button"
                    className="prop-iconbtn icon"
                    style={{ borderColor: "#fecaca", color: "#b91c1c" }}
                    title={t("delete")}
                    onClick={() => this.Delete(item)}
                  >
                    {ADMIN_ICON.trash}
                  </button>
                </div>
              )}
            </div>
          ))}

          {!list.length && (
            <div className="hmg-empty">
              <span className="icon">{ADMIN_ICON.star}</span>
              {t("home_empty_feature")}
            </div>
          )}
        </div>

        {/* แถบตัวเลข */}
        <div className="p-4 pt-3 border-top border-light">
          <div className="prop-title text-14 mb-1">
            <span className="prop-title__dot" />
            {t("home_stats_title")}
          </div>
          <div className="ppl-sub mb-3">{t("home_stats_desc")}</div>

          <div className="row g-3">
            {stats.map((item) => (
              <div className="col-md-6" key={item.uid}>
                <div className="d-flex gap-2">
                  <div style={{ width: "40%" }}>
                    <label className="prop-label">{t("home_stat_value")}</label>
                    <input type="text" className="prop-field" maxLength={10} value={item.value} onChange={(e) => this.setStat(item.uid, { value: e.target.value })} />
                  </div>
                  <div className="flex-grow-1">
                    <label className="prop-label">{t("home_stat_label")}</label>
                    <input type="text" className="prop-field" maxLength={26} value={item.label} onChange={(e) => this.setStat(item.uid, { label: e.target.value })} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ไม่มีสิทธิ์แก้ = ไม่ต้องมีแถบบันทึก ดูอย่างเดียว */}
        {can("homepage.update") && (
          <div className="ppl-savebar">
            {dirty ? (
              <span className="ppl-dirty">
                <span className="ppl-dirty__dot" />
                {t("unsaved_changes")}
              </span>
            ) : (
              <span className="text-secondary text-12 d-flex align-items-center gap-2">
                <span className="icon">{ADMIN_ICON.check}</span>
                {t("all_changes_saved")}
              </span>
            )}
            <div className="d-flex gap-2">
              <button type="button" className="prop-btn prop-btn--ghost" disabled={!dirty} onClick={this.Reset}>
                <span className="icon text-12">{ADMIN_ICON.reset}</span>
                {t("reset_changes")}
              </button>
              <button type="button" className="prop-btn" disabled={!dirty} onClick={this.Save}>
                <span className="icon text-12">{ADMIN_ICON.save}</span>
                {t("save_settings")}
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  /* ==================================================== render : กล่องพรีวิว */
  renderPreview = () => {
    const { section, stats } = this.state;
    const list = ordered(this.state.items).filter((item) => item.is_active);

    return (
      <div className="prop-card prop-in hmg-preview">
        <div className="prop-card__head">
          <span className="prop-title text-14">
            <span className="prop-title__dot" />
            {t("home_preview")}
          </span>
          <a className="prop-link" href="/" target="_blank" rel="noreferrer">
            <span className="icon text-12">{ADMIN_ICON.external}</span>
            {t("home_open_site")}
          </a>
        </div>

        <div className="p-3">
          <div className="hmg-frame">
            <div className="hmg-frame__bar">
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__dot" />
              <span className="hmg-frame__url">safespacelifeliving.com/#about</span>
            </div>
            <div className="hmg-frame__body" style={{ background: "#f7f9f6" }}>
              <div className="mn-home">
                <div className="hm-section__head" style={{ marginBottom: "14px" }}>
                  <div>
                    <h2 className="hm-section__title" style={{ fontSize: "18px" }}>
                      {section.title}
                    </h2>
                  </div>
                </div>

                {/* หน้าเว็บจริงวางการ์ดจุดเด่น (ซ้าย) คู่กับแถบตัวเลข (ขวา)
                    กล่องพรีวิวแคบกว่า จึงวางซ้อนกันลงมาแทน เนื้อหาเหมือนกันทุกจุด */}
                <div className="hm-features" style={{ gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: "10px", padding: "12px" }}>
                  {list.map((item) => (
                    <div className="hm-feature" key={item.uid} style={{ padding: "16px 14px" }}>
                      <div className="hm-feature__icon hm-ico" style={{ width: "38px", height: "38px", fontSize: "16px", marginBottom: "10px" }}>
                        {item.icon}
                      </div>
                      <div className="hm-feature__title" style={{ fontSize: "13.5px" }}>
                        {item.title}
                      </div>
                      <p className="hm-feature__desc" style={{ fontSize: "11.5px" }}>
                        {item.desc}
                      </p>
                    </div>
                  ))}
                </div>

                <div className="hm-stats" style={{ marginTop: "16px", padding: "16px 10px", gridTemplateColumns: "repeat(4, minmax(0, 1fr))" }}>
                  {stats.map((item) => (
                    <div className="hm-stat" key={item.uid}>
                      <div className="hm-stat__value" style={{ fontSize: "18px" }}>
                        {item.value}
                      </div>
                      <div className="hm-stat__label" style={{ fontSize: "10.5px" }}>
                        {item.label}
                      </div>
                    </div>
                  ))}
                </div>

                {!list.length && <div className="hmg-empty">{t("home_empty_feature")}</div>}
              </div>
            </div>
          </div>

          <div className="ppl-note mt-3">
            <span className="icon">{ADMIN_ICON.info}</span>
            <div>{t("home_feature_preview_hint")}</div>
          </div>
        </div>
      </div>
    );
  };

  /* ================================================== render : ฟอร์มเพิ่ม/แก้ */
  renderFormModal = () => {
    const { modal_form, edit_uid, form } = this.state;

    return (
      <Modal show={modal_form} onHide={this.CloseForm} size="lg" centered>
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white">
          <div>
            <h5 className="fw-bold mb-0 text-dark">{edit_uid ? t("home_edit_feature") : t("home_add_feature")}</h5>
            <div className="text-secondary text-12">{t("home_feature_form_desc")}</div>
          </div>
        </Modal.Header>

        <Modal.Body className="p-4 bg-white">
          {/* ตัวอย่างการ์ดจริง */}
          <div className="mn-home mb-4">
            <div className="hm-feature" style={{ maxWidth: "320px" }}>
              <div className="hm-feature__icon hm-ico">{form.icon}</div>
              <div className="hm-feature__title">{form.title || t("home_feature_placeholder_title")}</div>
              <p className="hm-feature__desc">{form.desc || t("home_feature_placeholder_desc")}</p>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-md-8">
              <label className="prop-label">
                {t("home_feature_title") } <span className="text-danger">*</span>
              </label>
              <input type="text" className="prop-field" maxLength={28} value={form.title} onChange={(e) => this.setForm({ title: e.target.value })} />
            </div>

            <div className="col-md-4">
              <label className="prop-label">{t("status")}</label>
              <div className="d-flex align-items-center gap-2" style={{ height: "44px" }}>
                <label className="ppl-switch">
                  <input type="checkbox" checked={form.is_active} onChange={(e) => this.setForm({ is_active: e.target.checked })} />
                  <span className="ppl-switch__track" />
                </label>
                <span className={`text-12 fw-bold ${form.is_active ? "text-success" : "text-secondary"}`}>
                  {form.is_active ? t("home_show") : t("home_hide")}
                </span>
              </div>
            </div>

            <div className="col-12">
              <label className="prop-label">{t("home_feature_desc_label")}</label>
              <textarea
                className="prop-field"
                rows={2}
                style={{ height: "auto", paddingTop: "10px" }}
                maxLength={110}
                value={form.desc}
                onChange={(e) => this.setForm({ desc: e.target.value })}
              />
              <div className="ppl-sub mt-1">{t("home_feature_desc_hint")}</div>
            </div>

            <div className="col-12">
              <label className="prop-label">{t("home_feature_icon")}</label>
              <div className="hmg-picker">
                {FEATURE_ICONS.map((icon) => (
                  <button key={icon} type="button" className={`hmg-picker__icon icon ${form.icon === icon ? "is-on" : ""}`} onClick={() => this.setForm({ icon })}>
                    {icon}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
          <button type="button" className="prop-btn prop-btn--ghost" onClick={this.CloseForm}>
            {t("cancel")}
          </button>
          <button type="button" className="prop-btn" onClick={this.SaveFeature}>
            <span className="icon text-12">{ADMIN_ICON.check}</span>
            {t("confirm")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    const { updated_at, updated_by } = this.state;

    return (
      <div className="w-100 min-vh-100 prop-page">
        <NavbarAdmin />
        <div className="body p-4">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3 prop-in">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("home_feature_manage")}</h3>
              <div className="text-secondary text-14">{t("home_feature_manage_desc")}</div>
            </div>
            <div className="text-secondary text-12 text-lg-end">
              <div>
                {t("updated")} {format_date(updated_at, "dd mmm yyyy hh:mm", locale())}
              </div>
              <div>
                {t("updated_by")} {updated_by}
              </div>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-xl-7 col-lg-7">{this.renderList()}</div>
            <div className="col-xl-5 col-lg-5">{this.renderPreview()}</div>
          </div>
        </div>

        {this.renderFormModal()}
      </div>
    );
  }
}
